module.exports = __webpack_public_path__ + "img/main_right3.d8035fc4.png";